import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./style.scss";

// INTERNAL PREVIEW — admin-only (gated via <Protected path="admin"> in App.js), noindex, not
// linked anywhere public. A hidden "duplicated nemastruje.com for dev" surface to preview the
// proposed Enterprise account type before it goes to live production. Not wired to billing.
const TIERS = [
  {
    name: "Enterprise",
    price: "312,49 €",
    pdv: "PDV uključen (249,99 € + 25%)",
    // Sidrena (dodatna) cijena — the 10.09.2026 price; must be displayed wherever the price is,
    // incl. this preview, once NN 101/2026 applies. Mirrors helpers/cjenik.py PRICE_HISTORY.
    anchor: "312,49 €",
    features: [
      "Neograničen broj adresa / objekata",
      "730 SMS godišnje (≈ 2 dnevno)",
      { text: "Dnevni status e-mailom — i kad nema prekida stiže „zeleno svjetlo” za rad" },
      "Poslovna podrška",
      { text: "Napredna nadzorna ploča", soon: true },
    ],
  },
  {
    name: "Enterprise Concierge",
    price: "587,50 €",
    pdv: "PDV uključen (470 € + 25%)",
    anchor: "587,50 €",
    highlight: true,
    features: [
      "Neograničen broj adresa / objekata",
      "730 SMS godišnje (≈ 2 dnevno)",
      { text: "Dnevni status e-mailom ili SMS-om — odaberete u nadzornoj ploči; i kad nema prekida stiže „zeleno svjetlo” za rad" },
      {
        text: "Mi unosimo adrese umjesto vas — pošaljete e-mail ili SMS s adresama, a mi ih dodamo",
        bold: true,
      },
      "Prioritetna podrška",
    ],
  },
];

const Check = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#ffb454"
    strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12l5 5L20 6" />
  </svg>
);

const Enterprise = () => {
  // Belt-and-suspenders: this route is already behind admin auth and unlinked, but tag it noindex.
  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex,nofollow";
    document.head.appendChild(m);
    return () => { document.head.removeChild(m); };
  }, []);

  return (
    <div className="ent-page">
      <header className="ent-top">
        <Link to="/" className="ent-brand">nemastruje<span>.com</span></Link>
        <span className="ent-badge">Interni preview · samo za admine · nije na produkciji</span>
      </header>

      <main className="ent-main">
        <h1>Enterprise — za građevinske firme i izvođače</h1>
        <p className="ent-lead">
          Za tvrtke s više gradilišta odjednom: znajte unaprijed hoće li dio kvarta ostati bez
          struje ili vode — da ne šaljete ekipe uzalud. Neograničen broj objekata, 730 SMS godišnje,
          dnevni status e-mailom i poslovna podrška.
        </p>

        <div className="ent-grid">
          {TIERS.map((t) => (
            <div key={t.name} className={`ent-card${t.highlight ? " hl" : ""}`}>
              <div className="ent-tag">{t.name}</div>
              <div className="ent-pr">{t.price} <small>/god</small></div>
              <div className="ent-pdv">{t.pdv}</div>
              <div className="ent-pdv">Sidrena cijena (10.09.2026.): {t.anchor}</div>
              <ul>
                {t.features.map((f, i) => {
                  const obj = typeof f === "string" ? { text: f } : f;
                  return (
                    <li key={i}>
                      <Check />
                      <span>
                        {obj.bold ? <b>{obj.text}</b> : obj.text}
                        {obj.soon && <span className="ent-soon">uskoro</span>}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>

        <p className="ent-foot">
          Ciljano: građevina, izvođači radova, upravitelji portfelja objekata s više gradilišta
          odjednom. Ovo je interni prijedlog — kasnije se promovira u javnu cijenu i poveže s
          naplatom. (Dnevni „zeleno svjetlo” e-mail/SMS je nova vrsta obavijesti — gradi se uz
          promociju u produkciju.)
        </p>
      </main>
    </div>
  );
};

export default Enterprise;
